<app-loading-panel
  *ngIf="!isLoaded"
  [showLoading]="true"
  [hideText]="true"
  [isSmall]="true"
></app-loading-panel>

<ng-container *ngIf="isLoaded">
  <ng-container *ngIf="rows.length; else emptyState">
    <!-- Desktop table. With mobileCards off there is no phone rendering to
         fall back to, so the table stays visible at every width. -->
    <div
      class="app-data-table"
      [ngClass]="mobileCards ? 'd-none d-md-block' : ''"
    >
      <table class="table" [class.table-fixed]="tableLayoutFixed">
        <thead>
          <tr>
            <th *ngIf="selectable" class="data-table-select-column">
              <app-checkbox
                [checked]="allSelected"
                (changeEvent)="toggleAll()"
              ></app-checkbox>
            </th>
            <th
              *ngFor="let col of columns"
              [ngClass]="[
                col.headerClass || '',
                col.align ? 'text-' + col.align : '',
                col.sortable ? 'data-table-sortable' : '',
                col.hideBelowLg ? 'd-none d-lg-table-cell' : '',
              ]"
              [style.width]="col.width || null"
              (click)="onHeaderClick(col)"
            >
              <ng-container *ngIf="col.header">{{
                col.header | translate
              }}</ng-container>
              <i
                *ngIf="col.sortable"
                class="fas ml-1"
                [ngClass]="sortIcon(col)"
              ></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let row of rows; trackBy: trackBy"
            [class.inactive-row]="rowInactive(row)"
            [class.clickable-row]="clickableRows"
            [class.selected-row]="selectable && isSelected(row)"
            [attr.data-testid]="rowTestId ? rowTestId(row) : null"
            (click)="onRowClick(row)"
          >
            <td *ngIf="selectable" class="data-table-select-column">
              <app-checkbox
                [checked]="isSelected(row)"
                [stopClickPropagation]="true"
                (changeEvent)="toggleRow(row, $event)"
              ></app-checkbox>
            </td>
            <td
              *ngFor="let col of columns"
              [ngClass]="[
                col.cellClass || '',
                col.align ? 'text-' + col.align : '',
                col.hideBelowLg ? 'd-none d-lg-table-cell' : '',
              ]"
            >
              <ng-container *ngIf="templateFor(col.key) as tpl; else plainCell">
                <ng-container
                  *ngTemplateOutlet="
                    tpl;
                    context: {
                      $implicit: row,
                      row: row,
                      value: cellValue(col, row),
                    }
                  "
                ></ng-container>
              </ng-container>
              <ng-template #plainCell>{{ cellValue(col, row) }}</ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Mobile cards -->
    <div class="d-block d-md-none app-data-table" *ngIf="mobileCards">
      <div
        class="data-table-mobile-card"
        *ngFor="let row of rows; trackBy: trackBy"
        [class.inactive-row]="rowInactive(row)"
        [class.clickable-row]="clickableRows"
        [class.selected-row]="selectable && isSelected(row)"
        [attr.data-testid]="
          mobileRowTestId
            ? mobileRowTestId(row)
            : rowTestId
              ? rowTestId(row)
              : null
        "
        (click)="onRowClick(row)"
      >
        <div class="mobile-row" *ngIf="selectable">
          <app-checkbox
            [checked]="isSelected(row)"
            [stopClickPropagation]="true"
            (changeEvent)="toggleRow(row, $event)"
          ></app-checkbox>
        </div>
        <div class="mobile-row" *ngFor="let col of mobileColumns">
          <span class="mobile-label" *ngIf="col.header">{{
            col.header | translate
          }}</span>
          <span class="mobile-value">
            <ng-container *ngIf="templateFor(col.key) as tpl; else plainMobile">
              <ng-container
                *ngTemplateOutlet="
                  tpl;
                  context: {
                    $implicit: row,
                    row: row,
                    value: cellValue(col, row),
                  }
                "
              ></ng-container>
            </ng-container>
            <ng-template #plainMobile>{{ cellValue(col, row) }}</ng-template>
          </span>
        </div>
        <div class="mobile-action-row" *ngIf="actionsColumn as ac">
          <ng-container
            *ngTemplateOutlet="
              templateFor(ac.key);
              context: { $implicit: row, row: row }
            "
          ></ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #emptyState>
    <div class="data-table-empty" [attr.data-testid]="emptyTestId">
      {{ emptyText | translate }}
    </div>
  </ng-template>
</ng-container>

<app-pager
  *ngIf="showPager"
  [totalPagesCount]="totalPages"
  [page]="pageNumber"
  [size]="pageSize"
  [variant]="pagerVariant"
  (paginate)="onPaginate($event)"
></app-pager>
